export default (theme) => ({
  header: {
    fontWeight: 'bold',
    width: 'inherit',
    transition: 'font-size .3s ease, color .3s linear',
  },
  subtitle: {
    fontSize: 28,
    fontWeight: 'bold',
    marginBottom: 10,
    opacity: 0,
    visibility: 'hidden',
    transition: 'opacity .5s ease',
  },
  activeSubtitle: {
    opacity: 1,
    visibility: 'visible',
    marginTop: 10,
  },
  smallHeader: {
    fontSize: 18,
    color: theme.palette.font.main,
  },
  headerWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: 0,
    margin: '10px 0',
    width: 'calc(100% - 30px)',
    textAlign: 'center',
    minHeight: 120,
    [theme.breakpoints.down('md')]: {
      margin: '20px 0',
    },
  },
  logo: {
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'block',
      width: 50,
      maxHeight: 50,
      height: 'auto',
      objectFit: 'contain',
      objectPosition: 'center',
    },
    [theme.breakpoints.down('sm')]: {
      width: 40,
      maxHeight: 40,
    },
  },
  bodyWrapper: {
    height: '100%',
    width: '100%',
    overflowY: 'auto',
    padding: '40px 80px 60px',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    minWidth: 1000,
    [theme.breakpoints.down('md')]: {
      padding: 40,
      minWidth: 'initial',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '40px 16px',
    },
  },
  smallBodyWrapper: {
    padding: '0 80px 60px',
  },
  wideBodyWrapper: {
    minWidth: 1000,
    [theme.breakpoints.down('md')]: {
      minWidth: 'initial',
    },
  },
  progress: {
    height: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    width: '100%',
    borderTop: `1px solid ${theme.palette.primary.main}`,
  },
  serviceCard: {
    boxSizing: 'border-box',
    width: '100%',
    minHeight: 135,
    height: 'auto',
    border: `1px solid ${theme.palette.disabled.main}`,
    borderRadius: 33,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 20,
    marginBottom: 10,
    cursor: 'pointer',
    backgroundColor: '#ffffff',
    transition: 'background-color .1s linear, border-color .1s linear',
    '&:hover': {
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.background.default,
    },
    '&:hover $arrow': {
      transform: 'rotate(180deg) translateX(-10px)',
    },
  },
  serviceCardInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    textAlign: 'left',
    width: 'calc(100% - 35px)',
  },
  checkMarkIcon: {
    width: 15,
    height: 15,
    fill: '#ffffff',
  },
  timeline: {
    width: '60%',
    maxWidth: '60%',
    margin: 0,
    padding: 0,
    flexDirection: 'row',
    justifyContent: 'space-evenly',
  },
  timelineDot: {
    width: 25,
    height: 25,
    margin: 0,
    position: 'relative',
    zIndex: 100,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  timelineItem: {
    minHeight: 0,
    '&:before': {
      display: 'none',
    },
  },
  arrow: {
    transform: 'rotate(180deg)',
    cursor: 'pointer',
    transition: 'transform .2s linear',
    '& svg': {
      fill: theme.palette.primary.main,
    },
  },
  serviceDescription: {
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: theme.palette.font.main,
    padding: '5px 0',
  },
  headInfo: {
    color: theme.palette.font.main,
    marginBottom: 20,
  },
  bookAppointmentServiceInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    paddingLeft: 35,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 16,
    },
  },
  serviceInfoItemWrap: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
  },
  progressSubtitle: {
    textAlign: 'center',
    position: 'relative',
    maxWidth: 'calc(100% - 50px)',
    width: 'fit-content',
    margin: '0 auto',
    marginBottom: 20,
  },
  confirmationSubtitle: {
    padding: '0 0 40px 0',
  },
  serviceDescriptionIcon: {
    marginRight: 5,
    width: 24,
    minWidth: 24,
    height: 24,
    minHeight: 24,
  },
  circleIcon: {
    position: 'absolute',
    right: '101%',
    top: 3,
  },
  calendarButton: {
    background: 'none',
    border: 'none',
    padding: 10,
  },
  backButton: {
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    position: 'absolute',
    top: 10,
    left: 10,
    padding: 0,
    '& svg': {
      width: 34,
      height: 34,
      transition: 'fill .2s linear',
      '&:hover': {
        fill: theme.palette.primary.main,
      },
    },
  },
  provider: {
    display: 'flex',
    alignItems: 'center',
  },
  capitalizedTitle: {
    fontWeight: 'bold',
    textTransform: 'capitalize',
  },
  providerInfoWrapper: {
    marginLeft: 20,
  },
  providerTag: {
    display: 'inline-block',
    color: theme.palette.secondary.main,
    padding: '6px 8px',
    backgroundColor: `${theme.palette.secondary.main}50`,
    borderRadius: 20,
    margin: '10px 10px 0 0',
  },
  bookAppointmentForm: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 20,
    width: '80%',
    margin: '0 auto',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  bookAppointmentFormWithAvailability: {
    width: '60%',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  selectorsWrapper: {
    display: 'flex',
    minHeight: 80,
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  selector: {
    width: 'calc(50% - 20px)',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginTop: 20,
    },
  },
  timeSlotSelector: {
    width: 'calc(50% - 20px)',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  submitButton: {
    alignSelf: 'flex-end',
  },
  availabilitySelector: {
    width: '100%',
    [theme.breakpoints.down('md')]: {
      marginTop: 20,
    },
  },
  mobileSelectedDate: {
    marginTop: 20,
    textAlign: 'center',
  },
  eventIcon: {
    fill: theme.palette.primary.main,
  },
  confirmEventIcon: {
    fill: theme.palette.background.white,
    marginRight: 10,
  },
  confirmationWrapper: {
    textAlign: 'center',
    maxWidth: '80%',
    margin: 'auto',
  },
  confirmButton: {
    marginLeft: 20,
    [theme.breakpoints.down('sm')]: {
      margin: '10px 0 0',
    },
  },
  confirmationIcon: {
    width: 115,
    height: 115,
  },
  controlButtons: {
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  noServiceTitle: {
    margin: 'auto',
    textAlign: 'center',
    color: theme.palette.font.main,
  },
  hiddenSelectors: {
    opacity: 0.5,
    cursor: 'default',
    pointerEvents: 'none',
  },
  serviceBackButton: {
    alignSelf: 'flex-end',
    margin: '0 65px 10px 0',
  },
  controlButton: {
    alignSelf: 'flex-end',
  },
  bookAppointmentServiceBackButton: {
    margin: 25,
    alignSelf: 'flex-end',
  },
});
